import { Divider, Flex, Form, Space } from 'antd';
import { InputDate } from 'Components/Inputs/InputDate';
import { SelectPlus } from 'Components/SelectPlus';
import { SearchButton } from '@shared/components/buttons/SearchButton';
import { ResetButton } from '@shared/components/buttons/ResetButton';
import { FilterField } from './FilterField';
import { UserTooltip } from '../UserTooltip';

export const Filters = ({ onSearch, users, compact }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    onSearch(values);
  }

  const handleSearch = () => {
    form.submit();
  };

  const handleResetFilters = () => {
    form.resetFields();
    form.submit();
  };

  const userOptions = users.map((record) => ({
    value: record.id,
    label: (
      <UserTooltip record={record}>
        {record.username}
      </UserTooltip>
    ),
  }));

  return (
    <Form
      form={form}
      onFinish={handleFinish}
      layout='vertical'
    >
      <Flex gap='middle' align='end'>
        <FilterField
          label='Usuarios'
          name='users'
          col={{ flex: '1' }}
          tooltip='Usuarios que han registrado eventos. La información mostrada refleja el estado del usuario en la fecha en que ocurrió cada evento.'
        >
          <SelectPlus
            mode='multiple'
            placeholder='Seleccionar usuarios'
            options={userOptions}
            allowClear
          />
        </FilterField>
        <FilterField label='Fecha' col={{ flex: '1' }} >
          <Space.Compact block style={{ gap: 4 }}>
            <FilterField name='timestampStart' col={{ flex: '1' }}>
              <InputDate placeholder='Desde' />
            </FilterField>
            <FilterField name='timestampEnd' col={{ flex: '1' }}>
              <InputDate placeholder='Hasta' />
            </FilterField>
          </Space.Compact>
        </FilterField>
        <Flex gap='small' align='center'>
          <SearchButton onClick={handleSearch} compact={compact} />
          <Divider type='vertical' style={{ borderInlineStartWidth: 4, height: '1.5em', margin: 0 }} />
          <ResetButton onClick={handleResetFilters} compact={compact} />
        </Flex>
      </Flex>
    </Form>
  );
}